import { isPhotoStatusPublished, type PostPhotoPrivacyStatus } from '@citizen-walk/shared-types';

/**
 * 写真の顔・ナンバーのぼかし処理の表示 (docs/28 §4-9)。
 *
 * - ほかの参加者 (`withheld=true`、写真は `usePosts` が出さない): 写真の場所に「写真は準備中です」。
 *   管理者の判断で公開しないと決まった写真は「写真は公開されていません」。
 * - 投稿者本人 (写真は見えている): 処理中・失敗・公開しないの注意書き。
 */
export interface PhotoPrivacyNoticeProps {
  status: PostPhotoPrivacyStatus | null | undefined;
  finalFailure: boolean;
  withheld: boolean;
}

export function photoPrivacyNoticeText({
  status,
  finalFailure,
  withheld,
}: PhotoPrivacyNoticeProps): string | null {
  if (withheld) {
    return status === 'withheld' ? '写真は公開されていません' : '写真は準備中です';
  }
  if (isPhotoStatusPublished(status)) return null;
  if (status === 'withheld') {
    return '管理者の判断で、この写真はほかの参加者に公開されません。';
  }
  if (status === 'failed' && finalFailure) {
    return '写真に写った人の顔や車のナンバーを隠す処理（プライバシー保護の処理）がうまくいきませんでした。管理者が確認したあとで、写真がほかの参加者に公開されます。';
  }
  return '写真に写った人の顔などを隠す処理をしています。終わるとほかの参加者に公開されます。';
}

export function PhotoPrivacyNotice(props: PhotoPrivacyNoticeProps) {
  const text = photoPrivacyNoticeText(props);
  if (!text) return null;
  if (props.withheld) {
    return (
      <p className="mb-3 rounded-lg border border-slate-200 bg-slate-50 py-8 text-center text-sm text-slate-500">
        {text}
      </p>
    );
  }
  return (
    <p
      role="status"
      className="mb-3 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900"
    >
      {text}
    </p>
  );
}
